module.exports = __webpack_public_path__ + "img/pdf.78401cbc.png";